import { render, staticRenderFns } from "./system-logs.vue?vue&type=template&id=b8fb3e2e"
import script from "./system-logs.vue?vue&type=script&lang=js"
export * from "./system-logs.vue?vue&type=script&lang=js"
import style0 from "./system-logs.vue?vue&type=style&index=0&id=b8fb3e2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports